import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/views/home';

Vue.use(VueRouter);

const routes = [
	// 餐饮美业专区落地页
	{
		path: '/',
		name: 'Home',
		component: Home
	}
];

const router = new VueRouter({
	mode: 'history',
	base: '/joblist-cateringbeauty/',
	routes
});

export default router;
